export interface VetAdviceBannerData {
  hideImage?: boolean;
}

export interface VetAdviceBannerProps extends VetAdviceBannerData {}
